import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
//变化中的组件
import HomeHeader from '@/components/MasterTop'
import CommonFooter from '@/components/MasterButtom'
import Banner from '@/components/CommonBanner'
import floatAd from '@/components/floatAd.vue'
import fixedImg from '@/components/fixedImg.vue'
import fileLoading from '@/components/fileLoading.vue'
var routes = {
	top: HomeHeader,
	footer: CommonFooter,
	banner:Banner,
	floatAd:floatAd,
	fixedImg:fixedImg,
	fileLoading:fileLoading
}
//页面
import Home from '@/pages/Home'
import Login from '@/pages/login/login.vue'
import ScriptPrePrintDetailed from '@/pages/ScriptPrePrintDetailed'
import PreprintList from '@/pages/PreprintList'
import gzhPreprintList from '@/pages/gzhPreprintList'
import Authorgarden from '@/pages/Authorgarden'
import comments from '@/pages/comments'
import AdvancedSearch from '@/pages/AdvancedSearch'
import QuickSearch from '@/pages/QuickSearch'
import digest from '@/pages/digest'
import dlistnum from '@/pages/dlistnum'
import gzhdlistnum from '@/pages/gzhdlistnum'
import DownloadlistViewlist from '@/pages/DownloadlistViewlist'
import Links from '@/pages/Links'
import NewsDetails from '@/pages/NewsDetails'
import gzhNewsDetails from '@/pages/gzhNewsDetails'
import NewsList from '@/pages/NewsList'
import gzhNewsList from '@/pages/gzhNewsList'
import OAList from '@/pages/OAList'
import gzhOAList from '@/pages/gzhOAList'
import Export from '@/pages/Export'
import FixedBody from '@/pages/FixedBody'
import gzhFixedBody from '@/pages/gzhFixedBody'
import LookforPassword from '@/pages/login/LookforPassword.vue'
import regist from '@/pages/regist/regist'
import FieldColumnList from '@/pages/FieldColumnList.vue'
import gzhFieldColumnList from '@/pages/gzhFieldColumnList.vue'
import Rss from '@/pages/Rss.vue'
import gzhRecommended from '@/pages/gzhRecommended.vue'
import error from '../components/404.vue';
//组件当中
import login_qq from '@/components/Login/Login_qq'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  	return originalPush.call(this, location).catch(err => err)
}

export default new Router({
//    mode: 'history',
  routes: [
	  {
		path: "/", //首页
		name: "author-index",
		components: {
		  default: Home,
		  ...routes
		},
		meta:{
			title:"Chinese Journal of Explosives & Propellants"
		}
	  },
	  {
	  		path: "/regist", 
	  		name: "regist",
			meta:{
				title:"Regist"
			},
	  		components: {
	  		   default:regist,
	  		  ...routes
	  		}
	  },
	
	  {
	  		path: "/LookforPassword", 
	  		name: "LookforPassword",
	  		components: {
	  		   default:LookforPassword,
	  		  ...routes
	  		},
	  		meta:{
	  			title:"LookforPassword"
	  		}
	  },
	
	  {
	  		path: "/FixedBody", 
	  		name: "FixedBody",
	  		components: {
	  		   default:FixedBody,
	  		  ...routes
	  		}
	  },
	  {
		path: "/gzhFixedBody", 
		name: "gzhFixedBody",
		components: {
		   default:gzhFixedBody,
			footer: CommonFooter,
			banner:Banner,
			floatAd:floatAd,
			fixedImg:fixedImg
		   
		},
		
	  },
	  
	  {
		path: "/gzhNewsDetails", 
		name: "gzhNewsDetails",
		components: {
		   default:gzhNewsDetails,
			footer: CommonFooter,
			banner:Banner,
			floatAd:floatAd,
			fixedImg:fixedImg
		   
		},
		
	  },
	  {
	  		path: "/Export", 
	  		name: "Export",
	  		components: {
	  		   default:Export,
	  		  ...routes
	  		},
	  		meta:{
	  			title:"Export"
	  		}
	  },
	  {
	  		path: "/OAList", 
	  		name: "OAList",
	  		components: {
	  		   default:OAList,
	  		  ...routes
	  		},
	  	
	  },
	  //公众号的最新一期/过刊目录
	  {
		path: "/gzhOAList", 
		name: "gzhOAList",
		components: {
		   default:gzhOAList,
			footer: CommonFooter,
			banner:Banner,
			floatAd:floatAd,
			fixedImg:fixedImg
		   
		},
		
},
	  {
	  		path: "/NewsList", 
	  		name: "NewsList",
	  		components: {
	  		   default:NewsList,
	  		  ...routes
	  		},
	  		meta:{
	  			title:"News"
	  		}
	  },
	  {
		path: "/gzhNewsList", 
		name: "gzhNewsList",
		components: {
		   default:gzhNewsList,
			footer: CommonFooter,
			banner:Banner,
			floatAd:floatAd,
			fixedImg:fixedImg
		   
		},
		
},
	  {
	  		path: "/NewsDetails", 
	  		name: "NewsDetails",
	  		components: {
	  		   default:NewsDetails,
	  		  ...routes
	  		},
	  		meta:{
	  			title:"News"
	  		}
	  },
	  {
	  		path: "/Links", 
	  		name: "Links",
	  		components: {
	  		   default:Links,
	  		  ...routes
	  		},
	  		meta:{
	  			title:"Links"
	  		}
	  },
	
	  {
	  		path: "/DownloadlistViewlist", 
	  		name: "DownloadlistViewlist",
	  		components: {
	  		   default:DownloadlistViewlist,
	  		  ...routes
	  		},
	  		meta:{
	  			title:"Download Rank"
	  		}
	  },
	  {
	  		path: "/dlistnum", 
	  		name: "dlistnum",
	  		components: {
	  		   default:dlistnum,
	  		  ...routes
	  		},
	  		meta:{
	  			title:"Archive"
	  		}
	  },
	  {
		path: "/gzhdlistnum", 
		name: "gzhdlistnum",
		components: {
		   default:gzhdlistnum,
		   footer: CommonFooter,
		   banner:Banner,
		   floatAd:floatAd,
		   fixedImg:fixedImg
		},
		meta:{
			title:"Archive"
		}
},
//公众号推荐文章
{
	path: "/gzhRecommended", 
	name: "gzhRecommended",
	components: {
	   default:gzhRecommended,
	   footer: CommonFooter,
	   banner:Banner,
	   floatAd:floatAd,
	   fixedImg:fixedImg
	},
	meta:{
		title:"Recommended article"
	}
},
	  {
	  		path: "/digest", 
	  		name: "digest",
	  		components: {
	  		   default:digest,
	  		  ...routes
	  		},
	  		meta:{
	  			title:"Details"
	  		}
	  },
	  {
	  		path: "/QuickSearch", 
	  		name: "QuickSearch",
	  		components: {
	  		   default:QuickSearch,
	  		  ...routes
	  		},
	  		meta:{
	  			title:"Search"
	  		}
	  },
	  {
	  		path: "/AdvancedSearch", 
	  		name: "AdvancedSearch",
	  		components: {
	  		   default:AdvancedSearch,
	  		  ...routes
	  		},
	  		meta:{
	  			title:"Advanced Search"
	  		}
	  },

	  {
	  		path: "/comments", 
	  		name: "comments",
	  		components: {
	  		   default:comments,
	  		  ...routes
	  		},
	  		meta:{
	  			title:"All comments"
	  		}
	  },
	  {
	  		path: "/Login", //登录
	  		name: "Login",
	  		components: {
	  		   default:Login,
			   ...routes
	  		},
	  		meta:{
	  			title:"Login"
	  		}
	  },
	  {
	  		path: "/login_qq", //登录
	  		name: "login_qq",
	  		components: {
	  		   default:login_qq,
	  		  ...routes
	  		},
	  		meta:{
	  			title:"QQ Login"
	  		}
	  },
	
    {
      path: '/ScriptPrePrintDetailed',
      name: 'ScriptPrePrintDetailed',
      components: {
        default: ScriptPrePrintDetailed,
        ...routes
      },
	  meta:{
	  	title:"Preprint"
	  }
    },
    {
      path: '/PreprintList',
      name: 'PreprintList',
      components: {
        default: PreprintList,
        ...routes
      },
	  meta:{
	  	title:"Preprint"
	  }
	},
	{
		path: '/gzhPreprintList',
		name: 'gzhPreprintList',
		components: {
		  default: gzhPreprintList,
		  footer: CommonFooter,
			banner:Banner,
			floatAd:floatAd,
			fixedImg:fixedImg
		},
		meta:{
			title:"Preprint"
		}
	  },
	  {
		path: '/Authorgarden',
		name: 'Authorgarden',
		components: {
		  default: Authorgarden,
		  ...routes
		},
		meta:{
			title:"For Authors"
		}
	  },
	  {
		path: '/FieldColumnList',
		name: 'FieldColumnList',
		components: {
		  default: FieldColumnList,
		  ...routes
		},
		
	  },
	  {
		path: "/gzhFieldColumnList", 
		name: "gzhFieldColumnList",
		components: {
		   default:gzhFieldColumnList,
		   footer: CommonFooter,
		   banner:Banner,
		   floatAd:floatAd,
		   fixedImg:fixedImg
		},
		meta:{
			title:"Archive"
		}
},
	  {
		path: "/Rss", 
		name: "Rss",
		components: {
		   default:Rss,
		  ...routes
		},
		meta:{
			title:"Rss"
		}
	  },
	  {
		path: "/404",
		name: "404",
		component: error
		}, 
	  {
		path: "*", // 此处需特别注意置于最底部
		redirect: "/404"
		},
  ]
})
